import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  downs: [],
  checkedDownExists: null,
  x: -1,
};

const getters = {
  getDowns: (state) => state.downs,
  getDownById: (state) => (id) => state.marks.find((x) => x.id == id),
  getCheckedDownExists: (state) => state.checkedDownExists,
};

const actions = {
  async exportDowns() {
    try {
      const resp = await api.get("/downs_export");
      if (resp.status == 200) {
        return resp.status;
      }
    } catch (error) {
      console.log("error", error);
      return error.status;
    }
  },
  async checkDownExists({ commit }, stu_num) {
    try {
      const resp = await api.get(`/down_check/${stu_num}`);
      if (resp.status == 200) {
        const down = resp.data.data.down;
        //.log("students", student);
        commit("setCheckedDownExists", down);
        return 200;
      } else {
        commit("setCheckedDownExists", null);
      }
    } catch (error) {
      //   console.log("error", error.status);
      //   console.log("error", error);
      commit("setCheckedDownExists", null);
      return error.status;
    }
  },

  async fetchDowns({ commit }) {
    try {
      const resp = await api.get("/downs");
      if (resp.status == 200) {
        const downs = resp.data.data.downs;
        console.log("downs", downs);
        commit("setDowns", downs);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateDown({ commit }, down) {
    console.log("down", down);

    try {
      const id = down.id;
      down._method = "patch";

      const resp = await api.post(`/downs/${id}`, down);
      if (resp.status == 200) {
        const down = resp.data.data;
        console.log("down back", down);
        commit("updateDown", down);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addDown({ commit }, down) {
    try {
      const resp = await api.post(`/downs`, down);

      if (resp.status == 201) {
        const down = resp.data.data;

        commit("addDown", down);
      }
      console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setDowns(state, downs) {
    state.downs = downs;
  },
  updateDown(state, down) {
    const id = down.id;
    const index = state.downs.findIndex((down) => down.id == id);
    if (index !== -1) {
      state.downs[index] = down;
    }
  },
  addDown(state, down) {
    state.downs.unshift(down);
  },

  setCheckedDownExists(state, mark) {
    state.checkedDownExists = mark;
  },
  updateMarkStatus(state, down) {
    const index = state.downs.findIndex((x) => x.id == down.id);
    if (index != -1) {
      state.downs[index].status = down.status;
      //console.log("cfdfciv uhiuhc", mark.status);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
